export async function openEditor(type, key) {
  const item = this.getItem(key, type) || this.getSelected()?.state
  if (!item) return

  const scope = this.getCanvasScope()
  const path = scope.hoverLayer
  this.syncCanvas()

  const showLayersSchema = scope.showLayersSchema || {}
  const componentShowLayersSchema = JSON.parse(
    JSON.stringify(showLayersSchema?.[item.key] || {})
  )

  if (!componentShowLayersSchema) return
  const updateShowLayers = (schema, path) => {
    let current = schema
    current.showLayers = true
    path?.some((key) => {
      if (key[0] !== key[0].toLowerCase()) {
        if (current[key] === undefined) {
          current[key] = {}
        }
        current[key].showLayers = true
        current = current[key]
      } else {
        return true
      }
    })
  }

  updateShowLayers(componentShowLayersSchema, path)

  const isActive = this.call('arraysEqual', path, scope.activeLayer || [])
  showLayersSchema[item.key] = componentShowLayersSchema
  scope.showLayersSchema = showLayersSchema

  if (isActive) {
    scope.activeLayer = null
  } else {
    scope.activeLayer = path.filter((key) => key[0] !== key[0].toLowerCase())
  }

  if (scope.componentEditor === 'code') {
    this.changeCodePriority('component')

    await this.getComponentCodeEditor().update(
      {},
      new ((this.call('sameOriginTop') || window).Object)({
        preventUpdate: true,
        allowCodeSelection: true
      })
    )
  }

  this.syncCanvas()

  const isExplorerActive = Boolean(scope.explorer)
  const isExplorerArtboardsActive = scope.explorer === 'explorer:ARTBOARD_TYPES'

  if (isExplorerActive && !isExplorerArtboardsActive) {
    this.setWindow('explorer', 'explorer:ARTBOARD_TYPES')
  }

  if (!scope.explorer && !scope.editorActive) return

  const t = setTimeout(async () => {
    const componentLayer = isExplorerActive
      ? this.call('findFileSidebarItem', item.type, item.key)
      : this.getQuickEditor()

    await componentLayer.state.update({
      showLayers: true
    })
    componentLayer.node.scrollIntoViewIfNeeded()
    // componentLayer.node.focus()
    clearTimeout(t)
  }, 350)
}
